/* RUDE BY NATURE — default-on automatic product photo cycling.
   Limited to sections that explicitly opt in. No hover/touch image-switch handlers. */
(() => {
  if (window.rbnCardAutoEffectsLoaded) return;
  window.rbnCardAutoEffectsLoaded = true;
  const css = document.createElement('style');
  css.textContent = [
    '[data-rbn-auto-zone] .rbn-card-effects-toolbar{display:flex;justify-content:flex-end;padding:12px clamp(16px,3vw,40px);max-width:1400px;margin:0 auto 10px;}',
    '[data-rbn-auto-zone] .rbn-card-effects-toolbar[hidden]{display:none!important;}',
    '[data-rbn-auto-zone] [data-rbn-auto-toggle]{cursor:pointer;min-height:44px;background:#111;color:#f3efe6;border:1px solid #e63926;padding:10px 18px;text-transform:uppercase;font:400 15px/1.1 var(--font-heading--family,Impact),Impact,sans-serif;letter-spacing:.025em;}',
    '[data-rbn-auto-zone] [data-rbn-auto-toggle]:hover{background:#e63926;color:#111;}',
    '[data-rbn-auto-zone] [data-rbn-auto-toggle]:focus-visible{outline:3px solid #f3efe6;outline-offset:3px;}',
    '[data-rbn-auto-zone] .card-gallery,[data-rbn-auto-zone] .rbn-new__media{position:relative;}',
    '[data-rbn-auto-zone] img.rbn-auto-second{position:absolute;inset:0;display:block;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;clip-path:inset(0 0 100% 0);transform:translateY(-5%);pointer-events:none;z-index:1;transition:clip-path 1.25s cubic-bezier(.23,.75,.25,1),transform 1.25s cubic-bezier(.23,.75,.25,1);}',
    '[data-rbn-auto-zone] .rbn-auto-is-second>img.rbn-auto-second{clip-path:inset(0 0 0 0);transform:translateY(0);}',
    '[data-rbn-auto-zone] .rbn-new__badge{z-index:2;}',
    '@media(prefers-reduced-motion:reduce){[data-rbn-auto-zone] img.rbn-auto-second{transition:none;}}'
  ].join('\n');
  document.head.append(css);
  function init(zone) {
    if (zone.dataset.rbnAutoInitialized) return;
    zone.dataset.rbnAutoInitialized = 'true';
    const toolbar = zone.querySelector('[data-rbn-auto-toolbar]');
    const button = toolbar?.querySelector('[data-rbn-auto-toggle]');
    if (!toolbar || !button) return;
    const entries = new Map();
    const observed = new IntersectionObserver(list => {
      list.forEach(item => {
        const entry = entries.get(item.target);
        if (entry) { entry.visible = item.isIntersecting; if (entry.visible && active) ensureImage(entry); }
      });
    }, {rootMargin: '100px'});
    let active = !window.matchMedia('(prefers-reduced-motion: reduce)').matches, timer = null, phase = 0, mutationPending = false;
    function scan() {
      zone.querySelectorAll('[data-rbn-auto-second]').forEach(card => {
        if (entries.has(card)) return;
        const holder = card.querySelector('.card-gallery, .rbn-new__media, .rbn-halloween-shop__media');
        const original = holder?.querySelector('img');
        const url = card.getAttribute('data-rbn-auto-second');
        if (!holder || !original || !url) return;
        entries.set(card, {holder, url, overlay: null, ready: false, visible: false});
        observed.observe(card);
      });
      for (const card of entries.keys()) if (!card.isConnected) entries.delete(card);
      toolbar.hidden = entries.size === 0;
      if (active && entries.size && timer === null) timer = setInterval(tick, 6500);
    }
    function ensureImage(entry) {
      if (entry.overlay) return entry.overlay;
      const img = document.createElement('img');
      img.className = 'rbn-auto-second';
      img.alt = '';
      img.decoding = 'async';
      img.loading = 'eager';
      img.src = entry.url;
      entry.holder.append(img);
      entry.overlay = img;
      entry.ready = false;
      /* Let the browser establish the fully hidden starting frame before animating. */
      (async () => {
        try { await img.decode(); } catch { return; }
        if (!img.isConnected || !img.naturalWidth) return;
        await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        entry.ready = true;
      })();
      return img;
    }
    function tick() {
      if (!active || document.hidden) return;
      phase += 1;
      let index = 0;
      for (const entry of entries.values()) {
        if (entry.visible && (index % 2) === (phase % 2)) {
          ensureImage(entry);
          /* Skip switching while an image is still loading or rendering its first frame. */
          if (entry.ready) entry.holder.classList.toggle('rbn-auto-is-second');
        }
        index += 1;
      }
    }
    function stop() {
      active = false;
      clearInterval(timer);
      timer = null;
      for (const entry of entries.values()) entry.holder.classList.remove('rbn-auto-is-second');
      button.setAttribute('aria-pressed','false');
      button.textContent = 'Turn on effects';
    }
    button.addEventListener('click', () => {
      if (active) {stop(); return;}
      scan();
      if (!entries.size) return;
      active = true;
      button.setAttribute('aria-pressed','true');
      button.textContent = 'Turn off effects';
      phase = 0;
      tick();
      timer = setInterval(tick, 6500);
    });
    button.setAttribute('aria-pressed', String(active));
    button.textContent = active ? 'Turn off effects' : 'Turn on effects';
    const mutation = new MutationObserver(() => {
      if (mutationPending) return;
      mutationPending = true;
      requestAnimationFrame(() => {mutationPending=false;scan();});
    });
    mutation.observe(zone,{childList:true,subtree:true});
    scan();
    document.addEventListener('shopify:section:unload', e => {
      if (e.target.contains(zone)) {stop();observed.disconnect();mutation.disconnect();}
    });
  }
  function boot() {document.querySelectorAll('[data-rbn-auto-zone]').forEach(init);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();
